import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-integration-bp-events-api-form',
  templateUrl: './integration-bp-events-api-form.component.html',
  styleUrls: ['./integration-bp-events-api-form.component.scss']
})
export class IntegrationBpEventsApiFormComponent {
  @Input() formGroup!: FormGroup;
}
